import { BLUEPRINTS, INDIS, LITTLE_BITS, SPHERO } from '../../constants'

export const RoutingProductMap = {
  edurobots: SPHERO,
  blueprint: BLUEPRINTS,
  indi: INDIS,
  littlebits: LITTLE_BITS
}
